module.exports = __webpack_public_path__ + "static/media/whatsapp.40de8d07.png";